<template>
  <b-row class="tabs mx-0 bg-black">
    <b-col class="tabs__item d-flex" cols="1" md="1"></b-col>
    <b-col
      v-for="item in items.filter((item) => item.show)"
      :key="item.key"
      class="tabs__item d-flex align-items-center justify-content-center font-weight-bold cursor_pointer"
      :class="
        item.isHover || item.isActive ? `bg-${item.theme} text-white` : ''
      "
      @click="setTab(item)"
      @mouseover="setHover(item, true)"
      @mouseleave="setHover(item, false)"
    >
      <span class="width-max-content">{{ item.caption }}</span>
    </b-col>
    <b-col
      v-for="item in items.filter((item) => !item.show)"
      :key="item.key"
      class="tabs__item d-flex"
    />
    <b-col class="tabs__item d-flex" cols="1" md="1"></b-col>
  </b-row>
</template>

<script>
import { onMounted, ref, toRefs, watch } from "vue";
export default {
  props: {
    parvandehModalState: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { parvandehModalState } = toRefs(props);

    const currentTab = ref(null);
    const items = ref([
      {
        caption: "خلاصه‌ی مدیریتی",
        description:
          "به صفحه نتایج ارزیابی خوش آمدید! در اینجا مروری بر ارزیابی‌های اخیر ما، از جمله داده‌های مربوط به مراکز ارزیابی، آزمون‌های روان‌سنجی، و توصیه‌هایی برای توسعه پیدا خواهید کرد. همچنین می توانید افراد مختلف را با هم مقایسه کنید. لطفاً این اطلاعات را به دقت بررسی کنید و از آن برای حمایت و راهنمایی اعضای تیم خود در جهت دستیابی به اهدافشان استفاده کنید. از مشارکت شما در این فرآیند سپاسگزاریم.<br>در این بخش می‌تواند فایل گزارش‌ ارزیابی‌های انجام شده را دانلود نمایید",
        firstTabTitle: "",
        key: "tab1",
        componentName: "tab1CardContent",
        theme: "green",
        isHover: false,
        isActive: false,
        show: true,
      },
      {
        caption: "نتایج ارزیابی شایستگی‌ها",
        description:
          "این صفحه به گونه ای طراحی شده است که یک نمای کلی از کل نمرات و جزئیات نمرات در هر تمرین از ارزیابی های اخیر مرکز ارزیابی ما را در اختیار شما قرار دهد.<br>کانون ارزیابی ما طیف وسیعی از رفتارهای مرتبط با ماموریت‌های کارکنان را ارزیابی می‌کند. در این صفحه، عملکرد هر تمرین شامل مهارت ها و رفتارهای ارزیابی شده و نمرات هر دسته را مشاهده خواهید کرد. از این اطلاعات می توان برای درک حوزه های قوت و فرصت های توسعه در مهارت ها و رفتارهای ارزیابی شده استفاده کرد.<br>ما بر این باوریم که این بازخورد برای کمک به شرکت کنندگان و مدیران آنها در درک مهارت ها و رفتارهای ارزیابی شده و ارائه بازخورد و مربیگری هدفمند برای کمک به بهبود مهارت ها و رفتارها در صورت نیاز ضروری است",
        firstTabTitle: "بازده انتظاری",
        key: "tab2",
        componentName: "tab2CardContent",
        theme: "orange",
        isHover: false,
        isActive: false,
        show: true,
      },
      {
        caption: "آزمون واتسون",
        description:
          "آزمون واتسون گلیزر توانایی‌های تفکر انتقادی را که برای موفقیت در بسیاری از مشاغل ضروری هستند، ارزیابی می‌کند.<br>تفکر انتقادی شامل تجزیه و تحلیل، ارزیابی و ترکیب اطلاعات برای تصمیم گیری آگاهانه و حل مشکلات است.<br>این صفحه به منظور ارائه یک نمای کلی از نتایج آزمون، از جمله نمره کلی و نمرات در هر بخش از آزمون، طراحی شده است. در این صفحه، عملکرد هر بخش از آزمون واتسون گلیزر، از جمله نمره و نمودار آن را خواهید دید.<br>با تمرکز بر توسعه مهارت های تفکر انتقادی در کنار استعداد شناسایی شده، افراد می توانند به پتانسیل کامل خود برسند و در شغل خود به موفقیت برسند.<br>صفحه ما یافته‌های  ارزشمندی در مورد توانایی‌های تفکر انتقادی ارائه می‌کند و می‌تواند افراد را در سفرشان برای تبدیل شدن به متفکران انتقادی مؤثرتر راهنمایی کند",
        firstTabTitle: "توانایی ادراکی",
        key: "tab3",
        algorithmName: "watson",
        componentName: "tab3CardContent",
        theme: "blue",
        isHover: false,
        isActive: false,
        show: true,
      },
      {
        caption: "آزمون واتسون",
        description:
          "آزمون واتسون گلیزر توانایی‌های تفکر انتقادی را که برای موفقیت در بسیاری از مشاغل ضروری هستند، ارزیابی می‌کند. تفکر انتقادی شامل تجزیه و تحلیل، ارزیابی و ترکیب اطلاعات برای تصمیم گیری آگاهانه و حل مشکلات است.<br>این صفحه به منظور ارائه یک نمای کلی از نتایج آزمون، از جمله نمره کلی و نمرات در هر بخش از آزمون، طراحی شده است. در این صفحه، عملکرد هر بخش از آزمون واتسون گلیزر، از جمله نمره و نمودار آن را خواهید دید.<br>با تمرکز بر توسعه مهارت های تفکر انتقادی در کنار استعداد شناسایی شده، افراد می توانند به پتانسیل کامل خود برسند و در شغل خود به موفقیت برسند.<br>صفحه ما یافته‌های  ارزشمندی در مورد توانایی‌های تفکر انتقادی ارائه می‌کند و می‌تواند افراد را در سفرشان برای تبدیل شدن به متفکران انتقادی مؤثرتر راهنمایی کند.<br><br>در این آزمون نمره منفی در تصحیح نتایج لحاظ شده است.",
        firstTabTitle: "توانایی ادراکی",
        key: "tab4",
        algorithmName: "watson_negative",
        componentName: "tab3CardContent",
        theme: "red",
        isHover: false,
        isActive: false,
        show: true,
      },
      {
        caption: "آزمون توانایی ادراکی عمومی",
        description:
          "آزمون هوش مدیریتی موسسه ساویل اسسمنت یک ابزار ارزیابی پیشرو است که توانایی‌های تفکر انتقادی و تصمیم‌گیری افراد را که برای رهبری و مدیریت مؤثر ضروری است، اندازه‌گیری می‌کند.<br>آزمون هوش مدیریتی سویفت برای ارزیابی توانایی فرد در تصمیم گیری سریع و دقیق در موقعیت‌های پیچیده و پویا طراحی شده است.<br>در این صفحه، نمرات هر بخش از آزمون را خواهید دید که بازخورد ارزشمندی در مورد مهارت‌های تفکر انتقادی و تصمیم گیری شرکت‌کننده ارائه می دهد.<br>با تمرکز بر توسعه تفکر انتقادی و مهارت‌های تصمیم‌گیری، افراد می‌توانند به رهبران یا مدیران اثربخش‌تری تبدیل شوند که آنها را برای عبور از چالش‌ها و دستیابی به اهداف سازمان مجهزتر می‌سازد.",
        firstTabTitle: "بازده انتظاری",
        key: "tab5",
        algorithmName: "IBF",
        componentName: "tab3CardContent",
        theme: "purple",
        isHover: false,
        isActive: false,
        show: true,
      },
      {
        caption: "آزمون هوش مدیریتی",
        description: "",
        firstTabTitle: "بازده انتظاری",
        key: "tab6",
        algorithmName: "management_intelligence",
        componentName: "tab3CardContent",
        theme: "green",
        isHover: false,
        isActive: false,
        show: true,
      },
      {
        caption: "آزمون نئو",
        description: "",
        firstTabTitle: "بازده انتظاری",
        key: "tab7",
        algorithmName: "neo",
        componentName: "tab3CardContent",
        theme: "orange",
        isHover: false,
        isActive: false,
        show: true,
      },
    ]);

    const setTab = (item) => {
      items.value = items.value.map((tab) => {
        const isActive = tab.key === item.key;
        return { ...tab, isActive };
      });
      item.isActive = true;
      currentTab.value = item;
    };
    const setHover = (item, state) => {
      item.isHover = state;
    };

    onMounted(() => setTab(items.value[0]));

    watch(parvandehModalState, (value) => !value && setTab(items.value[0]));

    // set active tab wit emit when current tab changed
    watch(currentTab, (value) => emit("getActiveTab", value));

    // return data to be used in template
    return { currentTab, items, setTab, setHover };
  },
};
</script>

<style lang="scss" scoped>
.bg-black {
  background-color: #000 !important;
}
.bg-green {
  background-color: #5eb48b !important;
}
.bg-blue {
  background-color: #86b8c9 !important;
}
.bg-orange {
  background-color: #f6be60 !important;
}
.bg-red {
  background-color: #d95650 !important;
}
.bg-purple {
  background-color: #665980 !important;
}
.text-white {
  color: #fff !important;
}
.tabs {
  &__item {
    background-color: #000000;
    color: #626a69;
    height: 30px;
    border-radius: 8px 8px 0 0 !important;
  }
}
.width-max-content {
  width: max-content;
}
</style>
